import {
    get,
    post,
    put,
    del
} from '../configApi'

//quiz
export async function getListQuiz(params) {
    return await get(`/livestream/live/listquiz`, params)
}
export async function insertQuiz(body) {
    return await post(`/quiz/manage/insert`, body)
}
export async function updateQuiz(body) {
    return await put(`/quiz/manage/update`, body)
}
export async function deleteQuiz(body) {
    return await del(`/quiz/manage/delete`, body)
}